"use client";
import { serviceData } from "@/theme/data/Data";
import React, { useRef, useState } from "react";
import CustomGsapHeaderAnimate from "../utils/CustomGsapHeaderAnimate";
import DivAnimateYAxis from "../utils/DivAnimateYAxis";

const RecipeSection = ({ productAllDetails }: any) => {
  const serviceRef = useRef<HTMLDivElement>(null);
  const [activeItemId, setActiveItemId] = useState<number>(1); // Default active item ID
  const handleMouseEnter = (id: number) => {
    setActiveItemId(id);
  };

  const handleMouseLeave = () => {
    // Do nothing or add additional logic if needed when mouse leaves
  };
  return (
    <section className="rv-20-service_section my-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="rv-20-service_section_heading">
              <CustomGsapHeaderAnimate>
                <p className="rv-20-service_sub_title rv-text-anime d-flex">
                  <span></span> Power of Millets
                </p>
              </CustomGsapHeaderAnimate>
              <CustomGsapHeaderAnimate>
                <h2 className=" justify-content-center_title rv-text-anime pb-5">
                  3 Easy & Tasty Recipes to Try
                </h2>
              </CustomGsapHeaderAnimate>
            </div>
          </div>
        </div>
        <DivAnimateYAxis className="row justify-content-center">
          {productAllDetails?.recipe?.map((item: any, index: any) => (
            <div className="col-lg-4 col-sm-10 col-md-6" key={index}>
              <div
                className={`rv-20-single_service ${
                  activeItemId === index ? "active" : ""
                }`}
              >
                <div className="rv-20-single_service_iamge">
                  <img src={item.imgMain} alt="image" />
                </div>
                <div
                  className="rv-20-single_service_content_main"
                  ref={serviceRef}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="visible-part">
                    {/* <div className="rv-20-single_service_content_top">
                      <div className="rv-20-single_service_icon">
                        <img src={item.imgIcon} alt="image" />
                      </div>
                    </div> */}

                    <div className="rv-20-single_service_content_title">
                      <h4>{item.title}</h4>
                    </div>
                  </div>
                  <div className="hidden-part">
                    <ul className="rv-20-single_service_list">
                      {item?.steps?.map((step: string, index: string) => (
                        <li key={index}>
                          <i className="fas fa-check"></i>
                          {step}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </DivAnimateYAxis>
      </div>

      {/* <span className="service-sh-1">
        <img src="assets/img/services/home-6-service-4.png" alt="image" />
      </span>
      <span className="service-sh-2">
        <img src="assets/img/services/home-6-service-5.png" alt="image" />
      </span> */}
    </section>
  );
};

export default RecipeSection;
